import React from 'react';

interface AuthorizeProps {
    if: boolean;
    deniedMessage?: string,
    redirectToErrorPage?: boolean
    throwError?: boolean
}

export const Throw401 = () => {
    throw new DOMException('You do not have access to the requested resource.', DOMException.INVALID_ACCESS_ERR.toString());
}

export const Authorized = (props: React.PropsWithChildren<AuthorizeProps>): JSX.Element => {
    return (
        props.if ? <>{props.children}</> : (
            props.redirectToErrorPage || props.throwError ? <Throw401 /> : (
                <> {props.deniedMessage && <span className="p-5">{props.deniedMessage}</span>}</>
            )
        )
    );
};

Authorized.defaultProps = {
    redirectToErrorPage: false,
    deniedMessage: undefined
}

export default Authorized;
